import styled from "styled-components"

import { ReactComponent as BellSlashIcon } from "assets/svg/notifications/icon-bell-slash.svg"

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  width: 100%;
`

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background-color: #e2e8f0;
  border-radius: 50%;

  svg {
    width: 32px;
    height: 32px;
    color: #334155;
  }
`

const Body = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  width: 100%;
  text-align: center;
`

const Title = styled.h3`
  font-weight: 500;
  font-size: 20px;
  color: #334155;
`

const Description = styled.p`
  font-size: 16px;
  color: #475569;
`

interface Props {
  hasFilters?: boolean
}

export const NotificationsEmptyState = ({ hasFilters = false }: Props) => {
  return (
    <Container>
      <IconWrapper>
        <BellSlashIcon />
      </IconWrapper>
      <Body>
        <Title>{hasFilters ? "No Notifications Found" : "No Notifications Yet"}</Title>
        <Description>
          {hasFilters
            ? "Try adjusting your filters to see more notifications."
            : "When you have notifications, they'll show up here."}
        </Description>
      </Body>
    </Container>
  )
}
